import { writable, derived } from 'svelte/store';
import { calculateSpeedup, type SpeedupMetrics } from '../src/speedup-core';

// All latencies stored in milliseconds
export const targetLatencyMs = writable(500);
export const draftLatencyMs = writable(50);
export const k = writable(5);
export const acceptanceProb = writable(0.6);

export const computation = derived(
  [targetLatencyMs, draftLatencyMs, k, acceptanceProb],
  ([$targetMs, $draftMs, $k, $prob]): SpeedupMetrics => {
    return calculateSpeedup({
      targetLatencyMs: $targetMs,
      draftLatencyMs: $draftMs,
      k: $k,
      acceptanceProb: $prob,
    });
  }
);
